import React, { useEffect } from "react";
import { withOnline } from "../../online";
import StateLabel from "./StateLabel";
function EssenceStateLabel(props) {
  useEffect(() => {
    if (props.onAfterStateChanged) {
      props.onAfterStateChanged(props.stateCode);
    }
  }, [props.stateCode]);

  return <StateLabel {...props} className="mx-2" />;
}

const mapOnlineProps = {
  stateLabel: (d) => d.statenewlabel,
  stateCode: (d) => d.statenewtypecode,
};
export default withOnline(EssenceStateLabel, mapOnlineProps);
